export const environment = {
  production: true,
  api: 'https://api.hr.tridentbmc.pl',
  dateFormat: 'YYYY-MM-DD',
  feVersion: '2.14.0',
  beVersion: '2.14.0',
  quickGuideEnabled: false,
  financialPanelEnabled: false,
};
